import { twClassMerge } from '@healthhub/react-ui';
import { Col, Modal, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { Button } from '@shared/components';
import { useLayoutViewContext } from '@shared/context';

interface Props {
  onCancel: () => void;
  onConfirm: () => void;
}

const HealthCaregiverRecordTypeConfirmModal = ({ onCancel, onConfirm }: Props) => {
  const { isMobileView, isSharedServiceView } = useLayoutViewContext();

  const { t } = useTranslation();

  const onConfirmModal = () => {
    onConfirm();
    Modal.destroyAll();
  };

  return (
    <div>
      <p className="text-center text-base font-bold">{t('caregivers.addCaregivers.healthRecords.modal.title')}</p>
      <p>{t('caregivers.addCaregivers.healthRecords.modal.healthierSGOnNote')}</p>
      <ul className="mx-4 mb-6 list-disc">
        <li>{t('caregivers.addCaregivers.healthRecords.modal.appointmentsText')}</li>
        <li>{t('caregivers.addCaregivers.healthRecords.modal.AppointmentsBookRescheduleCancelText')}</li>
        <li>{t('caregivers.addCaregivers.healthRecords.modal.healthScreeningAndEligibilityText')}</li>
        <li>{t('caregivers.addCaregivers.healthRecords.modal.immunisationsText')}</li>
      </ul>
      <Row gutter={[10, 10]}>
        <Col
          className={twClassMerge({
            'order-2': !isMobileView && !isSharedServiceView,
          })}
          span={!isMobileView && !isSharedServiceView ? 12 : 24}
        >
          <Button className="w-full" key="confirm" onClick={onConfirmModal}>
            {t('button.confirm')}
          </Button>
        </Col>
        <Col
          className={twClassMerge({
            'order-1': !isMobileView && !isSharedServiceView,
          })}
          span={!isMobileView && !isSharedServiceView ? 12 : 24}
        >
          <Button className="w-full" key="cancel" onClick={onCancel} variant="secondary">
            {t('button.cancel')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default HealthCaregiverRecordTypeConfirmModal;
